import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {IInput} from '../../../models/ISpec';
import {EntityAlert} from '../../../models/EntityAlert';
import {IInputACPreset, INPUT_AC_PRESET} from './preset/InputACPreset';
import {IEntityAlert} from '../../../models/common';
import {PresetComponent} from './preset/preset.component';
import {ResetSpecsService} from "../../reset-specs.service";
import {isNullOrUndefined} from "util";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {Subscription} from "rxjs";
import * as R from "ramda";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'edsng-v-input',
  templateUrl: './v-input.component.html',
  styleUrls: ['./v-input.component.css']
})
export class VInputComponent implements OnInit, AfterViewInit, OnDestroy {

  public preset = INPUT_AC_PRESET;
  _inputSpecForm: FormGroup;
  private handles: Subscription[] = [];

  @ViewChild(PresetComponent, {static: false}) presetCmp: PresetComponent;

  @Input() isAcDcMode: boolean = false;
  @Input() VinSpec: IInput<number>;
  @Input() VinValidation: IInput<IEntityAlert>;

  @Output() inputChange: EventEmitter<IInput<number>> = new EventEmitter<IInput<number>>();

  get vmaxCtrl() {return this._inputSpecForm.get('vmax'); }
  get vminCtrl() {return this._inputSpecForm.get('vmin'); }
  get freqCtrl() {return this._inputSpecForm.get('freq'); }

  constructor(private fb: FormBuilder, private reset: ResetSpecsService, private translate: TranslateService) {
    this._inputSpecForm = fb.group({
      vmin: [null],
      vmax: [null],
      freq: [null],
    });
  }


  ngAfterViewInit() {
    setTimeout(() => {
      // console.log('V input - ngAfterViewInit', this.VinSpec);
      if (this.isAcDcMode) {
        if (isFinite(this.VinSpec.min) || isFinite(this.VinSpec.max)) {
          this.vmaxCtrl.setValue(this.VinSpec.max);
          this.vminCtrl.setValue(this.VinSpec.min);
        } else {
          // set ACDC default values
          this.vmaxCtrl.setValue(INPUT_AC_PRESET[0].VinMax);
          this.vminCtrl.setValue(INPUT_AC_PRESET[0].VinMin);
        }
      } else {
        this.vmaxCtrl.setValue(this.VinSpec.max);
        this.vminCtrl.setValue(this.VinSpec.min);
      }
      this.freqCtrl.setValue(this.VinSpec.freq.toString(10));
    }, 0);
  }

  ngOnInit() {

    const handle = this._inputSpecForm.valueChanges
      .pipe(distinctUntilChanged((prev, curr) => R.equals(prev, curr)), debounceTime(300))
      .subscribe(x => {
        // console.log('V input - value changed,', x);
        this.updatePresetDesc();
        const vInput: IInput<number> = {min: x.vmin, max: x.vmax, freq: Number.parseInt(x.freq, 10)};
        this.inputChange.emit(vInput);
      });
    this.handles.push(handle);
    const handle1 = this.reset.onReset
      .subscribe(() => {
        // console.log('V input - Reset');
        // this.updatePresetDesc();
        if (this.isAcDcMode) {
          this._inputSpecForm.setValue({vmin: INPUT_AC_PRESET[0].VinMin, vmax: INPUT_AC_PRESET[0].VinMax, freq: INPUT_AC_PRESET[0].fLineNom.toString(10)});
        } else {
          this._inputSpecForm.setValue({vmin: NaN, vmax: NaN, freq: '50'});
        }
      });
    this.handles.push(handle1);
  }

  ngOnDestroy() {
    this.handles.forEach(x => x.unsubscribe());
  }

  presetChange($event: IInputACPreset) {
    // console.log("V input - Preset", $event , this._inputSpecForm);
    this._inputSpecForm.setValue({vmin: $event.VinMin, vmax: $event.VinMax, freq: $event.fLineNom.toString(10)});
  }

  getTypeName(i: IEntityAlert) {
    return EntityAlert.getTypeName(i);
  }

  getMessage(i: IEntityAlert) {
    if (i) {
      return EntityAlert.getMessage(i, this.translate);
    }
    return '';
  }

  updatePresetDesc() {
    if (!isNullOrUndefined(this.presetCmp)) {
      this.presetCmp.setSelectedAC(this.vminCtrl.value, this.vmaxCtrl.value, Number.parseInt(this.freqCtrl.value, 10));
    }
  }

  onVinChange(text) {
    // this.updatePresetDesc();
  }
}
